import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../config";

export const fetchHealthInfo = createAsyncThunk(
  "healthInfo/fetchStudentHealthInfo",
  async (studentId) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      const userData = storedUser ? JSON.parse(storedUser) : null;
      const storedToken = localStorage.getItem("token");

      if (!userData || !storedToken) {
        throw new Error("No user data or token found");
      }
      // console.log("storedToken", storedToken);
      // console.log("studentId", studentId);
      const response = await fetch(
        `${API_BASE_URL}/api/HealthInformation/find/${studentId}`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch health info: ${errorText}`);
      }
      const data = await response.json();
      return Array.isArray(data) ? data : [data]; // Adjusting to always return an array
    } catch (error) {
      console.error("Error fetching  health info:", error);
      throw error;
    }
  }
);
export const fetchAllHealthInfos = createAsyncThunk(
  "HealthIssue/fetchAllStudentHealthIssues",
  async (_, { dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      const userData = storedUser ? JSON.parse(storedUser) : null;
      const storedToken = localStorage.getItem("token");
//      console.log("0-----------------data", userData);
      if (!userData || !storedToken) {
        throw new Error("No user data or token found");
      }

      const allHealthInfos = [];
      for (const studentId of userData.studentIds) {
//        console.log("0-----------------studentId", studentId);
        // Await the response and store it in a variable
        const response = await dispatch(fetchHealthInfo(studentId)).unwrap(); // Use unwrap to handle the payload directly
        // Ensure response is an array and spread into allHealthIssues
        if (Array.isArray(response)) {
          allHealthInfos.push(...response);
        } else {
          console.warn(
            `Expected an array for studentId ${studentId}, but received:`,
            response
          );
        }
      }

      return allHealthInfos; // Return all health issues
    } catch (error) {
      console.error("Error fetching all health infos:", error);
      throw error; // Rethrow the error for Redux to handle it
    }
  }
);


export const createHealthInfo = createAsyncThunk(
  "healthInfo/createHealthInfo",
  async ({ studentId, healthData }, { rejectWithValue }) => {
    try {
      const dataToSubmit = {
        ...healthData, // Existing health data
        studentId: studentId, // Append studentId
      };

      const storedToken = localStorage.getItem("token");

      if (!storedToken) {
        return rejectWithValue("No authorization token found");
      }
      // console.log("healthData, studentId", healthData, studentId);
      // console.log("dataToSubmit", dataToSubmit);
      const response = await fetch(
        `${API_BASE_URL}/api/HealthInformation/Create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storedToken}`,
          },
          body: JSON.stringify(dataToSubmit),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        return rejectWithValue(`Failed to create health info: ${errorText}`);
      }

      const data = await response.json();
      return data; // Return the created health information
    } catch (error) {
      return rejectWithValue("Error creating health info:", error);
    }
  }
);

// Function to update health information
export const updateHealthInfo = createAsyncThunk(
  "healthInfo/updateHealthInfo",
  async ({ studentId,healthId, healthData }, rejectWithValue) => {
    try {
           const dataToSubmit = {
             ...healthData, // Existing health data
             studentId: studentId, // Append studentId
           };

      const storedToken = localStorage.getItem("token");
/*       console.log(
        "updateHealthInfo: healthData, studentId",
        healthData,
        studentId
      ); */
 
      if (!storedToken) {
        return rejectWithValue("No authorization token found");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/HealthInformation/Update/${healthId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storedToken}`,
          },
          body: JSON.stringify(dataToSubmit),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
         return rejectWithValue(`Failed to update health info: ${errorText}`);
      }

      const data = await response.json();
      return data; // Return the updated health information
    } catch (error) {
          return rejectWithValue("Error updating health info:", error);
    }
  }
);
const healthInfoSlice = createSlice({
  name: "healthInfo",
  initialState: {
    healthInfoList: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHealthInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHealthInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.healthInfoList = action.payload;
      })
      .addCase(fetchHealthInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const healthInfoSelector = (state) => state.healthInfo;

export default healthInfoSlice.reducer;
